import { Link, Outlet, useLoaderData, useLocation, useSearchParams } from "react-router-dom";

import ServerFooter from "../common/ServerFooter";
import { Vendor } from "./types";

export const extraFields = ["page", "limit"];

export default function VendorList() {
    const [searchParams] = useSearchParams();
    const { vendors, total }: { vendors: Vendor[]; total: number } = useLoaderData() as { vendors: Vendor[]; total: number };
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;

    return (
        <div className = "cssContent pb8rem">
            <div className = "mt-2">
                <Link className = "btn btn-outline-primary pointer position-relative" to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                    {onFilter ? <span className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{ minWidth: "2.4em" }}>on</span> : null}
                </Link>
                <Link className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}>
                    Export
                </Link>
                <Link className = "btn btn-outline-primary float-end" to = "Add">
                    Add
                </Link>
            </div>
            {!vendors.length ? (
                <div className = "cssLoading">Empty</div>
            ) : (
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th>Vendor Name</th>
                                <th>Website</th>
                                <th>Business Phone</th>
                                <th>Fax</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {vendors.map((vendor, key) => (
                                <tr key = {key}>
                                    <td>{vendor.vendorName}</td>
                                    <td>{vendor.website ? <a href = {vendor.website} target = "_blank" rel = "noreferrer">{vendor.website}</a> : null}</td>
                                    <td>{vendor.phoneNumber ? <a href = {`tel:+1${vendor.phoneNumber.replace(/-/g, "")}${vendor.extension ? `,${vendor.extension}` : ""}`}>{vendor.phoneNumber}{vendor.extension ? ` Ext. ${vendor.extension}` : null}</a> : null}</td>
                                    <td>{vendor.fax ? <a href = {"fax:+1" + vendor.fax.replace(/-/g, "")}>{vendor.fax}</a> : null}</td>
                                    <td><Link className = "btn btn-outline-primary" to = {String(vendor.id)}>Detail</Link></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {total > 0 ? <ServerFooter length = {total} /> : null}
            <Outlet />
        </div>
    );
}
